module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ef-Gb.69bedf15.png";